/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Terms_Meta_TitleInputs */

const ja_playdata_terms_meta_title = /** @type {(inputs: Playdata_Terms_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用規約`)
};

const en_playdata_terms_meta_title = /** @type {(inputs: Playdata_Terms_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms`)
};

/**
* | output |
* | --- |
* | "Terms" |
*
* @param {Playdata_Terms_Meta_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_terms_meta_title = /** @type {((inputs?: Playdata_Terms_Meta_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Terms_Meta_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_terms_meta_title(inputs)
	return en_playdata_terms_meta_title(inputs)
});